import React, { useCallback, useEffect, useState } from "react"
import { Image, ScrollView, Text, View } from "react-native";
import { debounce } from "lodash";
import { store } from "../../store/store";
import { handleModalBackpress } from "../CommonService";

import { MoengageEvents, trackMoengageEvents } from "../../utils/services/webapp-services/MoengageUtils";
import { backpressBheaviour$, commonModalData$, consultationListSubscriptionForConsultationDetails } from "../../utils/services/subject-behaviour/CommonRxjsService";

import { AayuFollowUpBadge } from "../../utils/widgets/CommonAayuLogo";
import { CommonHeader } from "../../utils/widgets/CommonWidget/CommonHeader";
import { getImagePath, isObjectNotEmpty } from '../../utils/services/CommonUtils';
import { checkConsultationType, getConsultFromID } from "../../utils/services/econsult/EConsultUtils";
import { DoctorViewDesign, PrescriptionViewDesign, RefundedViewDesign, UserViewDesign, VIPViewDesign } from "../../utils/widgets/ActivityViewDesign";

import AppTheme from "../../AppTheme";
import TextStyle from "../../TextStyle";
import AppStyles from "../../AppStyles";
import DoctorProfilePopUp from "../../utils/modals/DoctorPopUp";

const consultationStatusValue = [
    'Case submitted',
    'Doctor is assigned',
    'Doctor reviews the case',
    'Doctor calls you',
    'Doctor shares the prescription'
];

const consultationStatusIndex = {
    Unassigned: 1,
    Pending: 2,
    Ongoing: 4,
    Consulted: 5,
    'Visit in person': 6,
    Refunded: 7,
}

const SingleConsultView = (props) => {

    const [consultationData, updateConsultationData] = useState();

    const [showDoctorProfileModal, setShowDoctorProfileModal] = useState(false)

    const setDoctorProfileModal = (modalData) => {
        handleModalBackpress(modalData, {
            showModal: showDoctorProfileModal,
            setModal: setShowDoctorProfileModal,
            modalDataSubscriber: modalDataSubscriber
        })
    }

    const modalDataSubscriber = useCallback(debounce((modalData) =>
        commonModalData$.next({ active: modalData.active }), 200), [])

    useEffect(() => {

        consultationListSubscriptionForConsultationDetails.getConsultList().subscribe((consultationList) => {
            if (consultationList && consultationList.length > 0) {
                updateConsultationData(getConsultFromID(
                    consultationList, props.route.params?.consultationId))
            }
        })
        trackMoengageEvents(MoengageEvents.econsult_details)

        backpressBheaviour$.subscribe((backpressData) => {
            setDoctorProfileModal({ active: false })
        })
    }, [])

    function getCheckIcon() {
        return <View style={{
            borderRadius: 50, backgroundColor: AppTheme.color.green.primary,
            borderWidth: 0.1, borderColor: AppTheme.color.green.primary
        }}>
            <Image source={{ uri: getImagePath('/images/icons/green_tick.svg'), height: 22, width: 22 }} />
        </View>
    }

    function getUncheckIcon() {
        return <View style={{
            borderRadius: 20, padding: 10, backgroundColor: AppTheme.color.white,
            borderWidth: 1, borderColor: AppTheme.color.green.primary
        }} />
    }

    function checkIsOngoingCall(consultationData) {
        if (consultationData.etxData)
            return consultationData.etxData.callConnected;
        else return false;
    }

    function getBottomMargin(consultationData) {
        return (506 + (consultationData['doctorProfile'] &&
            isObjectNotEmpty(consultationData['doctorProfile']) ? 98 : 0)) +
            AppTheme.appWidth * 0.35 - AppTheme.appHeight
    }

    return (consultationData ? <View>
        <CommonHeader navigation={props.navigation}
            title={'Consultation Details'} />

        <ScrollView style={{
            marginTop: AppTheme.headerHeight,
            marginBottom: getBottomMargin(consultationData),
            paddingVertical: 16
        }}>

            <UserViewDesign consultationData={consultationData} />

            {consultationData['doctorProfile'] &&
                isObjectNotEmpty(consultationData['doctorProfile']) ?
                <DoctorViewDesign consultationData={consultationData}
                    setDoctorPopup={setDoctorProfileModal} /> : null
            }


            {
                consultationStatusIndex[consultationData['status']] > 4 ?
                    consultationStatusIndex[consultationData['status']] == 5 ?
                        <PrescriptionViewDesign consultationData={consultationData} /> :
                        consultationStatusIndex[consultationData['status']] == 6 ?
                            <VIPViewDesign consultationData={consultationData} /> :
                            consultationStatusIndex[consultationData['status']] == 7 ?
                                <RefundedViewDesign consultationData={consultationData} /> : <View /> :
                    <View style={{
                        backgroundColor: AppTheme.color.purple.lightBg,
                        paddingHorizontal: 16,
                        paddingVertical: 25,
                        marginTop: 16
                    }}>
                        <Text style={[AppStyles.mdText, { marginBottom: 18, color: AppTheme.color.primary }]}>
                            {checkConsultationType(consultationData['serviceName'])} Status</Text>
                        {
                            consultationStatusValue.map((value, index) => (
                                <View style={{ marginLeft: 22 }} key={index}>
                                    {index > 0 ? <View style={{
                                        backgroundColor: AppTheme.color.green.primary,
                                        height: 21, width: 1.5, marginLeft: 10
                                    }} /> : <View />}
                                    <View style={[AppStyles.flexRow]}>
                                        {index < consultationStatusIndex[consultationData['status']] &&
                                            index < 2 ? getCheckIcon() : checkIsOngoingCall(consultationData) && index != 4 ?
                                            getCheckIcon() : getUncheckIcon()}
                                        <Text style={[TextStyle.text16b, { marginLeft: 12 }]}>{value}</Text>
                                    </View>
                                </View>
                            ))
                        }
                    </View>
            }
        </ScrollView>

        <View style={[AppStyles.bottomFix]}><AayuFollowUpBadge /></View>

        <DoctorProfilePopUp showPopUp={showDoctorProfileModal}
            hideDoctorsPopUp={setDoctorProfileModal}
            doctorProfileData={consultationData['doctorProfile']} />

    </View> : null)
}

export default SingleConsultView;
